import { render, staticRenderFns } from "./BlockCustomerProperties.vue?vue&type=template&id=25c42325&scoped=true&"
import script from "./BlockCustomerProperties.vue?vue&type=script&lang=js&"
export * from "./BlockCustomerProperties.vue?vue&type=script&lang=js&"
import style0 from "./BlockCustomerProperties.vue?vue&type=style&index=0&id=25c42325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c42325",
  null
  
)

export default component.exports